export default "__VITE_ASSET__gON_26rE__"